import React from 'react';
import 'twin.macro';
import { Field } from 'react-final-form';
import useClassrooms from '@teetsh/app/src/containers/App/context/ClassroomsContext/useClassrooms';
import Select from '@teetsh/app/src/components/Form/Select2';
import { replaceItemAtIndex } from '@teetsh/app/src/utils/listMethods';
import { allNiveaux } from '@teetsh/app/src/types/classroom';
import { ClassroomNiveauMapping } from '@teetsh/app/src/containers/EmploiDuTemps/EDT/Sidebar/EDTSendToCMSModal/types';
import { ArrowRightIcon as ArrowRight } from '@heroicons/react/24/outline';
import Label from '@teetsh/app/src/components/Form/Label';
import InputGroup from 'components/Form/InputGroup/formWrapper';
import { useTranslation } from 'react-i18next';

export default function Body() {
  const allClassrooms = useClassrooms();
  const { t } = useTranslation(['common', 'emploiDuTemps']);

  return (
    <div>
      <Field<ClassroomNiveauMapping[]>
        name="classroomsNiveauxMapping"
        label={
          allClassrooms.length > 1
            ? 'Niveau de la classe'
            : 'Niveau des classes'
        }
        render={({ input: { value, onChange } }) => (
          <div tw="ml-0.5 mb-8">
            <Label>
              {allClassrooms.length > 1
                ? 'Niveau des classes'
                : 'Niveau de la classe'}
            </Label>
            {value.map((v, index) => (
              <div
                tw="grid grid-cols-12 items-center md:gap-4"
                key={v.classroom.id}
              >
                <div tw="col-span-3">{v.classroom.name}</div>
                <div tw="col-span-2 text-center">
                  <ArrowRight tw="h-7 w-7" />
                </div>
                <div tw="col-span-7 max-w-min">
                  <Select<string>
                    portal
                    options={[
                      ...allNiveaux,
                      { value: 'IGNORE', label: 'Ignorer' },
                    ]}
                    value={v.niveau}
                    onChange={n =>
                      onChange(
                        replaceItemAtIndex(
                          value,
                          {
                            ...v,
                            niveau: n,
                          },
                          index,
                        ),
                      )
                    }
                  />
                </div>
              </div>
            ))}
          </div>
        )}
        large
      />
      <Field
        name="destEDTId"
        label={t('emploiDuTemps:sendToCMSEdtIdLabel')}
        helperText={t('emploiDuTemps:sendToCMSEdtIdHelperText')}
        component={InputGroup}
        large
      />
    </div>
  );
}
